<template>
    <div class="pt-16">
        <div class="relative">
            <div class="lg:absolute lg:top-0 lg:right-0 lg:h-full lg:w-[calc(50%+4.5rem)] xl:w-[calc(50%+5rem)] z-1">
                <div class="relative w-full h-[calc(35vw+6.5rem)] lg:h-full overflow-hidden">
                    <object
                        class="absolute -bottom-1 left-0 sm:hidden"
                        type="image/svg+xml"
                        style="filter: none"
                        :data="require('assets/images/shapes/waves/article-hero-wave_sm.svg')"
                    ></object>
                    <object
                        class="absolute -bottom-1 left-0 hidden sm:block lg:hidden"
                        type="image/svg+xml"
                        style="filter: none"
                        :data="require('assets/images/shapes/waves/article-hero-wave_md.svg')"
                    ></object>
                    <object
                        class="absolute bottom-0 -left-1 hidden lg:block"
                        type="image/svg+xml"
                        style="filter: none"
                        :data="require('assets/images/shapes/waves/article-hero-wave_lg.svg')"
                    ></object>
                    <picture>
                        <source media="(min-width:992px)" :srcset="$getMediaImage(model.media, 'hero', 'lg')" />
                        <source media="(min-width:480px)" :srcset="$getMediaImage(model.media, 'hero', 'md')" />
                        <img
                            :src="$getMediaImage(model.media, 'hero', 'sm')"
                            :alt="model.title"
                            class="w-full h-full object-cover"
                        />
                    </picture>
                </div>
            </div>
            <div class="container relative py-4 lg:py-12 lg:min-h-[600px] z-2">
                <div class="grid grid-cols-12 base-responsive-gap">
                    <div class="col-span-12 lg:col-span-5 order-2 lg:order-1 relative">
                        <h1 class="header-2 mb-4 lg:mb-8">{{ model.title }}</h1>
                        <div class="text-gray-400 font-bold uppercase text-sm mb-4 lg:mb-8">
                            <span>
                                {{ $dayjs(model.published_at).format('YYYY/MM/DD') }}
                            </span>
                            <span v-if="model.category_id" class="inline">
                                <span class="separator-bullet"></span>
                                {{ $getNewsCategoryLabel(model.category_id) }}
                            </span>
                        </div>
                        <div class="lead" v-html="model.lead_text"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-6 hidden lg:block">
            <Breadcrumb :items="breadcrumbItems" />
        </div>

        <EditableContentComponentGroup :components="model.components" class="mt-8 lg:mt-20 bg-theme-dark--swiper" />

        <section v-if="recommendedArticles.length" class="mt-16 sm:mt-24 lg:mt-32">
            <div class="container grid grid-cols-12 mb-10">
                <div class="col-span-12 sm:col-span-6 lg:col-span-7">
                    <h2 class="header-2"><T t="news.recommended_news" /></h2>
                </div>
            </div>
            <CardCarousel type="article" :items="recommendedArticles" class="bg-theme-dark--swiper" />
        </section>
    </div>
</template>

<script>
import Breadcrumb from '@/components/Generic/Breadcrumb.vue';
import CardCarousel from '@/components/Carousels/CardCarousel/CardCarousel.vue';
import EditableContentComponentGroup from '@/components/Generic/EditableContentComponentGroup.vue';

export default {
    name: 'MagazineEndpageTemplate',
    components: {
        EditableContentComponentGroup,
        CardCarousel,
        Breadcrumb,
    },
    props: {
        model: {
            type: Object,
            required: true,
        },
        recommendedArticles: {
            type: Array,
            required: true,
        },
        breadcrumbItems: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped></style>
